import {create} from "node:domain";
import {createContext, FC, ReactNode, useContext, useEffect, useState} from "react";

const AuthContext = createContext({
    isLoggedIn: false,
    isGranted: false,
    loading: true,
    error: null,
});

interface AuthProviderProps {
    children: ReactNode;
}

export const AuthProvider: FC<AuthProviderProps> = ({children}) => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isGranted, setIsGranted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch(`${import.meta.env.VITE_API_URL}/index.php?option=com_user_sk&task=profile.isPointsGranted`, {
            method: "GET",
        })
            .then(res => {
                if (!res.ok) throw new Error("Failed to fetch user data");
                return res.json();
            })
            .then(data => {
                setIsGranted(data?.isGranted);
                if (data?.isLogged) {
                    setIsLoggedIn(true);
                } else {
                    if (import.meta.env.VITE_REQ_LOGIN === "true") {
                        window.location.href = import.meta.env.VITE_HOME_URL;
                    }
                }
                setLoading(false);
            })
            .catch(err => {
                setError(err?.message);
                setIsLoggedIn(false);
                setLoading(false);
            })
    }, []);

    return (
        <AuthContext.Provider value={{isLoggedIn, isGranted, loading, error}}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuthContext = () => useContext(AuthContext);